import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">重要公告</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">重要公告</div>
        <div className="w-[930px] mx-auto pt-[72px] h5:w-full h5:px-16">
          <img src={require("../../assets/image/icon24.jpg")} alt="" className="w-full" />
        </div>

        <div className="text-[#181512] text-[44px] font-bold text-center py-[72px] h5:px-16">大家都在看</div>
        <Product />

        <br /><br /><br />
        <div className="text-[#181512] text-[44px] font-bold text-center py-[72px] h5:px-16">  活動優惠 </div>
        <More />

      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
